import React, { useContext } from "react";
import Context from "../OriginStoryProvider";
import TopTextSection from "./TopTextSection";
import FullWidthImage from "../Shared/FullWidthImage";
import HeadlineQuote from "../Shared/HeadlineQuote";
import Paragraph from "../Shared/Paragraph";
import AnimatedSeals from "./AnimatedSeals";
import ParagraphWithBg from "./ParagraphWithBg";
import LargeQuote from "../Shared/LargeQuote";
import PinnedImage from "./PinnedImage";
import Handwriting from "./Handwriting";
import QuoteWithImg from "../Shared/QuoteWithImg";
import AnimatedDates from "./AnimatedDates";

const Chapter1 = () => {
	const {
		data: { content },
	} = useContext(Context);

	if (!content.chapters) return null;

	return (
		<section id="chapter-1" className="chapter-1">
			<div className="chapter-1__title-container">
				<p className="chapter-1__label label-text">
					{content.chapters.first.label}
				</p>
				<h2 className="chapter-1__title">{content.chapters.first.title}</h2>
			</div>

			<TopTextSection />
			<FullWidthImage
				elClass="chapter-1__full-width-img--1"
				imgSizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (max-width: 2000px) 2000px, (max-width: 2400px) 2400px, (min-width: 2401px) 2879px"
				imgSrcset={`${mainScript.assetPath}images/webp/chapter-1/mt-baldy-400w.webp 400w, 
						${mainScript.assetPath}images/webp/chapter-1/mt-baldy-600w.webp 600w, 
						${mainScript.assetPath}images/webp/chapter-1/mt-baldy-800w.webp 800w, 
						${mainScript.assetPath}images/webp/chapter-1/mt-baldy-1000w.webp 1000w, 
						${mainScript.assetPath}images/webp/chapter-1/mt-baldy-1200w.webp 1200w, 
						${mainScript.assetPath}images/webp/chapter-1/mt-baldy-1600w.webp 1600w, 
						${mainScript.assetPath}images/webp/chapter-1/mt-baldy-2000w.webp 2000w,
						${mainScript.assetPath}images/webp/chapter-1/mt-baldy-2400w.webp 2400w,
						${mainScript.assetPath}images/webp/chapter-1/mt-baldy-2879w.webp 2879w`}
				imgCaption={content.chapters.first.full_width_img_1.caption}
				imgSrc={`${mainScript.assetPath}images/png/mt-baldy.png`}
				imgAlt={content.chapters.first.full_width_img_1.alt}
				imgWidth="2880"
				imgHeight="893"
			/>
			<HeadlineQuote
				elClass="chapter-1__headline-quote--1"
				quote={content.chapters.first.headline_quote.quote}
				source={content.chapters.first.headline_quote.citation}
			/>
			<Paragraph
				elClass="chapter-1__paragraph--1"
				text={content.chapters.first.paragraph_1.text}
			/>
			<AnimatedSeals />
			<ParagraphWithBg
				elClass="chapter-1__paragraph-with-bg--1"
				text={content.chapters.first.paragraph_with_bg}
			/>
			<LargeQuote
				elClass="chapter-1__large-quote--1"
				quote={content.chapters.first.large_quote_1.quote}
				source={content.chapters.first.large_quote_1.attribution}
				imgSrc={`${mainScript.assetPath}images/svg/graphics/bg-shape--purple-circle.svg`}
			/>
			<PinnedImage />
			<LargeQuote
				quote={content.chapters.first.large_quote_2.quote}
				source={content.chapters.first.large_quote_2.attribution}
				imgSrc={`${mainScript.assetPath}images/svg/graphics/bg-shape--purple-circle.svg`}
				elClass="chapter-1__large-quote--2"
			/>
			<Handwriting />
			<QuoteWithImg
				imgSrcset={`${mainScript.assetPath}images/webp/chapter-1/central-pacific-railroad-400w.webp 400w,
						${mainScript.assetPath}images/webp/chapter-1/central-pacific-railroad-600w.webp 600w,
						${mainScript.assetPath}images/webp/chapter-1/central-pacific-railroad-800w.webp 800w,
						${mainScript.assetPath}images/webp/chapter-1/central-pacific-railroad-1000w.webp 1000w,
						${mainScript.assetPath}images/webp/chapter-1/central-pacific-railroad-1200w.webp 1200w,
						${mainScript.assetPath}images/webp/chapter-1/central-pacific-railroad-1600w.webp 1600w,
						${mainScript.assetPath}images/webp/chapter-1/central-pacific-railroad-2000w.webp 2000w,
						${mainScript.assetPath}images/webp/chapter-1/central-pacific-railroad-2400w.webp 2400w,
						${mainScript.assetPath}images/webp/chapter-1/central-pacific-railroad-2879w.webp 2879w`}
				imgSizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (max-width: 2000px) 2000px, (max-width: 2400px) 2400px, (min-width: 2401px) 2879px"
				imgSrc={`${mainScript.assetPath}images/jpg/central-pacific-railroad.jpg`}
				quote={content.chapters.first.quote_with_img.quote}
				citation={content.chapters.first.quote_with_img.attribution}
				imgCaption={content.chapters.first.quote_with_img.img_caption}
				imgAlt={content.chapters.first.quote_with_img.img_alt}
				elClass="chapter-1__quote-with-img--1"
				imgHeight="1068"
				imgWidth="2880"
			/>
			<LargeQuote
				quote={content.chapters.first.large_quote_3.quote}
				source={content.chapters.first.large_quote_3.attribution}
				imgSrc={`${mainScript.assetPath}images/svg/graphics/bg-shape--curved-purple.svg`}
				elClass="chapter-1__large-quote--3"
			/>
			<AnimatedDates />
		</section>
	);
};

export default Chapter1;
